/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: HighCash.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  27.09.22 12:19 pm.
 * Last modified: 27.09.22 12:19 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { getGamesMinDenomination } from '../../api/helpers';
import { useSettings } from '../../contexts/SettingsContext';
import StandardJackpot from './StandardJackpot';

const HighCashJackpot = () => {
    const [settings] = useSettings();
    const currency = settings.currency;
    const highCashSection = settings.sections.find(section => section.name === 'HIGH_CASH');
    const minDenomination: number = getGamesMinDenomination(highCashSection?.games || [], settings.currency);

    return (
        <StandardJackpot
            icons={{
                panel: `${settings.host}/assets/portal/group_high_cash/logo.png`,
                grand: `${settings.host}/assets/portal/group_high_cash/grand.png`,
                major: `${settings.host}/assets/portal/group_high_cash/major.png`,
                minor: `${settings.host}/assets/portal/group_high_cash/minor.png`,
                mini: `${settings.host}/assets/portal/group_high_cash/mini.png`,
            }}
            values={{
                grand: 1,
                major: 2,
                minor: 3,
                mini: 4,
            }}
            defaultValues={{
                minor: 3000,
                mini: 1500,
            }}
            padding={{
                left: 25,
                right: 5,
                top: -30,
            }}
            denomination={minDenomination}
            currency={currency}
            jackpotName="High Cash"
            sectionName="HIGH_CASH"
        />
    );
};

export default HighCashJackpot;
